// extracted by mini-css-extract-plugin
export default {"container":"ScreenAreaDots_container__JylYy","dot":"ScreenAreaDots_dot__ZpwDi"};